export const RX_SERVICE_UUID = '6e400001-b5a3-f393-e0a9-e50e24dcca9e';
export const RX_CHAR_UUID = '6e400002-b5a3-f393-e0a9-e50e24dcca9e';
export const TX_CHAR_UUID = '6e400003-b5a3-f393-e0a9-e50e24dcca9e';
